export default {
    title: 'Contract list',
    breadcrumbs: {
        home: 'Home',
        titleBreadcrumbs: 'Contract list'
    },
    input:{
        lableCode:'Code',
        lableStatus:'Status',
        placeholderStatus:'All'

    },
    Button:{
        search:'Search',
        refresh:'Refresh'
    },
    table:{
        code:'Code',
        name:'Name',
        value:'Value',
        type:'Type',
        supervisor:'Supervisor ',
        status:'Status',
        rowsPerPage: 'Rows per page',
    },


    status: {
        waitSign: 'Wait sign',
        processing: 'Processing',
        liquidation: 'Liquidatied',
        closed: 'Closed',
        success:'Success sign',
        
        rejected:'Rejected',
    },
    type: {
        new: 'NEW',
        extenstion: 'EXTENSION',
    }
}